import { COLORS, useToast } from '@repo/design-system/index'
import { QIcon_check_outline, QIcon_send } from '@repo/icons/index'
import { useMutation } from '@tanstack/react-query'
import { ai_tutor_apis } from '../../../modules/apis'
import { axiosPost } from '../../../modules/axiosHelper'
import { n_ai_tutor } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import LoadingSpinner from '../../common/LoadingSpinner'

const useRequestMoreCourse = () => {
  return useMutation({
    mutationFn: async (jobCategoryId) => {
      const response = await axiosPost(ai_tutor_apis.voc.addMoreCourse(), { job_category_id: jobCategoryId })
      return response
    },
  })
}

const VOCBanner = ({ jobId, jobCategoryId, JobList }) => {
  const { t } = useTranslation()
  const { toastSuccess, toastError } = useToast()

  const {
    mutate: requestMoreCourse,
    isSuccess: isRequestMoreCourseSuccess,
    isLoading: isRequestMoreCourseLoading,
  } = useRequestMoreCourse()

  const GLOBAL_FIELD_ENGLISH_ID = 23
  const isGlobalFieldEnglishTab = jobId === GLOBAL_FIELD_ENGLISH_ID && jobCategoryId !== 0

  if (!isGlobalFieldEnglishTab) return null

  const currentJop = JobList?.find((list) => list.id === GLOBAL_FIELD_ENGLISH_ID)
  const currentJobCategory = currentJop?.categories?.find((list) => list.job_category_id === jobCategoryId)
  const currentJobCategoryTitle = currentJobCategory?.title

  const handleAddMoreCourse = () => {
    requestMoreCourse(jobCategoryId, {
      onSuccess: () => {
        toastSuccess(t(n_ai_tutor.banner.voc_plus.t_success))
      },
      onError: () => {
        toastError(t(n_ai_tutor.banner.voc_plus.t_fail))
      },
    })
  }

  return (
    <section className="mx-20 mt-20 mb-40 py-32 px-16 flex flex-col items-center justify-center gap-y-16 rounded-xl bg-gray-50">
      <p className="Title1-20Bd text-center">{t(n_ai_tutor.banner.voc_plus.title(currentJobCategoryTitle))}</p>

      <button
        className={`min-w-[180px] px-24 py-12 rounded-[8px] border-[1.5px]  flex justify-between items-center gap-x-4 ${
          isRequestMoreCourseSuccess || isRequestMoreCourseLoading
            ? 'bg-gray-200 border-gray-200'
            : 'bg-white border-gray-300'
        }`}
        onClick={isRequestMoreCourseSuccess ? null : handleAddMoreCourse}
      >
        {isRequestMoreCourseLoading ? (
          <div className="w-full flex justify-center items-center">
            <LoadingSpinner sm show primary />
          </div>
        ) : (
          <>
            {isRequestMoreCourseSuccess ? (
              <QIcon_check_outline width={16} height={16} color={COLORS.WHITE} />
            ) : (
              <QIcon_send width={16} height={16} color={COLORS.GRAY300} />
            )}
            <span className={`Body2-14Bd ${isRequestMoreCourseSuccess ? 'text-white' : ''}`}>
              {t(
                isRequestMoreCourseSuccess ? n_ai_tutor.banner.voc_plus.cta_sent : n_ai_tutor.banner.voc_plus.cta_active
              )}
            </span>
          </>
        )}
      </button>
    </section>
  )
}

export default VOCBanner
